export { default as ApiClient } from './ApiClient'
import ApiClient, { API_BASE_URL } from './ApiClient'

export { API_BASE_URL }

// Create a singleton instance of the API client
const apiClientInstance = new ApiClient(API_BASE_URL)

export const getApiClient = () => apiClientInstance
export { apiClientInstance as apiClient }
